import { Controller } from "@hotwired/stimulus"

const DAYS_PER_MONTH = 365 / 12

export default class extends Controller {
  static targets = [
    "price",
    "billingInterval",
    "billingPeriod",
    "billingPanel",
    "modelFixed",
    "modelArpu",
    "arpuPreview",
    "colorPicker",
    "colorInput"
  ]

  static values = {
    currency: String
  }

  connect() {
    this.onModelChange()
    this.recalculate()
  }

  onModelChange() {
    const isArpu = this.modelArpuTarget.checked
    this.billingPanelTarget.classList.toggle("d-none", isArpu)
  }

  selectColor(event) {
    event.preventDefault()
    const color = event.currentTarget.dataset.color
    this.colorInputTarget.value = color
    this.colorPickerTarget.querySelectorAll(".segment-color-swatch").forEach((button) => {
      button.classList.toggle("is-selected", button.dataset.color === color)
    })
  }

  recalculate() {
    if (!this.hasArpuPreviewTarget) return
    const monthly = this.monthlyPrice()
    this.arpuPreviewTarget.textContent = `${this.formatMoney(monthly)} / мес.`
  }

  monthlyPrice() {
    const price = Number(this.priceTarget.value) || 0
    if (this.modelArpuTarget.checked) return price

    const interval = Math.max(1, Number(this.billingIntervalTarget.value) || 1)
    const period = this.billingPeriodTarget.value
    const months = this.billingCycleMonths(interval, period)
    if (!months) return 0
    return price / months
  }

  billingCycleMonths(interval, period) {
    switch (period) {
      case "day":
        return interval / DAYS_PER_MONTH
      case "week":
        return (interval * 7) / DAYS_PER_MONTH
      case "month":
        return interval
      case "year":
        return interval * 12
      default:
        return interval
    }
  }

  formatMoney(amount) {
    const rounded = Math.round(amount * 100) / 100
    const formatted = rounded.toLocaleString("ru-RU", {
      minimumFractionDigits: Number.isInteger(rounded) ? 0 : 2,
      maximumFractionDigits: 2
    })
    return `${this.currencyValue}${formatted}`
  }
}
